$( document ).on("turbo:load", function(){

  function populateVariants(duplicate, variant_selector, variants) {
    var app = $('#node_app_id :selected').val();
    var options = $(variants).filter(`optgroup[label='${app}']`).html();
    duplicate.parent().show()
    if (options) {
      variant_selector.html(options)
      variant_selector.parent().show();
      var currentVariant = $('#current_variant_id').val()
      if (currentVariant != $('#node_variant_id :selected').val()) {
        duplicate.parent().hide()
      }
    } else {
      variant_selector.empty();
      variant_selector.parent().hide();
    }
  }

  if ($('#duplicate-modal').length > 0) {
    var variant_selector = $('#node_variant_id')
    var parent_selector = $('#node_parent_id');
    var variants = variant_selector.html();
    var parents = parent_selector.html();
    var duplicate = $('#node_is_duplicate')

    variant_selector.parent().hide();
    parent_selector.parent().hide();
    populateVariants(duplicate, variant_selector, variants)
    populateParents(parents, parent_selector)

    $('#node_app_id').on('change', function () {
      populateVariants(duplicate, variant_selector, variants)
      populateParents(parents, parent_selector)
    });

    variant_selector.on('change', function () {
      var currentVariant = $('#current_variant_id').val()
      if (currentVariant != $('#node_variant_id :selected').val()) {
        duplicate.parent().hide()
      } else {
        duplicate.parent().show()
      }
      populateParents(parents, parent_selector);
    });
  }

  setDefault();

  if ($('.section-group-form').length > 0) {
    const node = 'Node',
          map = 'Map',
          page = 'Page';

    var sections = $('#sections'),
        pages = $('#pages'),
        maps = $('#maps'),
        nodeData = $('#section_node'),
        pageData = $('#section_page'),
        mapData = $('#section_map'),
        mainData,
        dataType,
        elt,
        id,
        table,
        tr,
        destroyBtn,
        label,
        dataId,
        position,
        inputs;

    $('.sortable').sortable({
      axis: 'y',
      handle: '.sortable-handle',
      update: function() {
        setPositions()
      }
    });

    $.fn.updateDelete = function() {
      $('.delete-data').on('click', function(event) {
        event.preventDefault();
        tr = $(this).closest('tr');
        destroyBtn = tr.find('.destroy');
        dataType = this.closest('.section-group-data').dataset.type;

        if (dataType == node) {
          nodeData.find('option[value=' + tr.find('.data-id').val() + ']').prop('disabled', false)
        } else if (dataType == page) {
          pageData.find('option[value=' + tr.find('.data-id').val() + ']').prop('disabled', false)
        } else if (dataType == map) {
          mapData.find('option[value=' + tr.find('.data-id').val() + '][data-map-type=' + tr.find('.data-type').val() + ']').prop('disabled', false)
        }

        if (destroyBtn[0] != undefined) {
          destroyBtn[0].value = true;
          tr.find('.position').remove();
          tr.find('.data-id').remove();
          tr.hide()
        } else {
          tr.remove()
        }

        setPositions()
      });
    };

    $(document).updateDelete();

    $('.open-modal').on('click', function() {
      mainData = $(this).closest('.section-group-data');
      dataType = this.closest('.section-group-data').dataset.type;

      mainData.find('.data-id').each(function() {
        if (dataType == node) {
          nodeData.find('option[value=' + this.value + ']').prop('disabled', 'disabled')
        } else if (dataType == page) {
          pageData.find('option[value=' + this.value + ']').prop('disabled', 'disabled')
        } else if (dataType == map) {
          mapData.find('option[value=' + this.value + '][data-map-type=' + $(this).parent().find('.data-type').val() + ']').prop('disabled', 'disabled')
        }
      });
    });

    $('.add-data').on('click', function(e) {
      e.preventDefault();
      $(this).closest('.modal').find('#close-modal').click();

      mainData = $(this).closest('.section-group-data');
      dataType = this.closest('.section-group-data').dataset.type;
      id = sections.children().length + pages.children().length + maps.children().length + 1;

      if (dataType == node) {
        elt = document.getElementById('section_node');
        table = sections;
      } else if (dataType == page) {
        elt = document.getElementById('section_page');
        table = pages;
      } else if (dataType == map) {
        elt = document.getElementById('section_map');
        table = maps;
        dataType = elt.options[elt.selectedIndex].dataset.mapType;
      }

      if (elt.selectedIndex != 0) {
        label = elt.options[elt.selectedIndex].text;
        dataId = elt.options[elt.selectedIndex].value;
        position = mainData.find('.position').length + 1;
        inputs =
          '<td class="sortable-handle ui-sortable-handle"><i class="glyphicon glyphicon-sort"></i></td>' +
          '<td>' + label + '</td>' +
          '<td align="right" class="options"><a class="delete-data" href="#"><i title="" data-toggle="tooltip" data-placement="top" class="glyphicon glyphicon-trash" data-original-title="Delete"></i></a></td>' +
          '<input type="hidden" class="data-id" name="section_group[section_group_data_attributes][' + id + '][data_id]" id="data_id" value=' + dataId + '>' +
          '<input type="hidden" class="position" name="section_group[section_group_data_attributes][' + id + '][position]" id="position" value=' + position + '>' +
          '<input type="hidden" class="data-type" name="section_group[section_group_data_attributes][' + id + '][data_type]" id="data_type" value=' + dataType + '>';

        table.append('<tr>' + inputs + '</tr>');
        $(document).updateDelete();
        $('[data-toggle="tooltip"]').tooltip();
        elt.selectedIndex = 0;
        return elt.options[elt.selectedIndex].text
      }
    });

    function setPositions() {
      $('.position').each(function(i) {
        this.value = i + 1
      });
    }
  }

});

function setDefault() {
  if ($('.section-group-index').length > 0) {
    $('.is_default').on('click', function() {
      $.ajax({
        type: 'PUT',
        dataType: 'script',
        url: 'section_groups/set_default_section',
        data: { id: $(this).attr('section_id'), section_group: { is_default: $(this).is(':checked') ? true : false }}
      });
    });
  }
}

function populateParents(parents, parent_selector) {
  var variant = $('#node_variant_id :selected').val();
  $.ajax({
    url: "/admin/nodes",
    method: "GET",
    dataType: "json",
    data: {variant_id: variant},
    error: function (xhr, status, error) {
      console.error('AJAX Error: ' + status + error);
    },
    success: function (response) {
      var nodes = response["nodes"];
      parent_selector.empty();
      if (nodes) {
        for(var i = 0; i < nodes.length; i++){
          parent_selector.append('<option value="' + nodes[i]["id"] + '">' +nodes[i]["name"] + '</option>');
        }
        parent_selector.parent().show();
      } else {
        parent_selector.empty();
        parent_selector.parent().hide();
      }
    }
  });
}
